var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loadingError && !_vm.isAvailable)?_c('page-error-iquote-not-available'):_c('div',[_c('div',{staticClass:"container container-full-width-small px-0"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }